import React, { Component } from "react";
import Helmet from "react-helmet";
import AdminSidebar from "./AdminSidebar";
import AdminBody from "./AdminBody";

export default class Admin extends Component {
  render() {
    const { experiences, loading, rooms, setRooms, setExperiences } =
      this.props;

    return (
      <>
        <Helmet>
          <title>Lapwing - Admin</title>
        </Helmet>
        <div
          style={{
            height: "100%",
            backgroundColor: "#E6E2B1",
            display: "flex",
          }}
        >
          <AdminSidebar
            experiences={experiences}
            loading={loading}
            setExperiences={setExperiences}
          />
          <AdminBody
            experiences={experiences}
            loading={loading}
            rooms={rooms}
            setRooms={setRooms}
            setExperiences={setExperiences}
          />
        </div>
      </>
    );
  }
}
